<template>
        <div v-if="loggedIn" class="flex justify-center mt-5">
            <div>
                <img v-if="user.pic_url_photo" :src="user.pic_url_photo" class="w-24 rounded rounded-full"/>
                <img v-else src="../assets/portrait_placeholder.png" class="w-24 rounded rounded-full"/>
            </div>
            <div>
                <span class="text-gray-600 ml-2 block">{{ firstName }}</span>
                <span class="text-gray-600 ml-2 block">{{ lastName }}</span>
            </div>
        </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "ProfilePicture",
        computed: {
            ...mapGetters('auth', {
                'loggedIn': 'loggedIn',
                'user': 'user'
            }),
            firstName() {
                try {
                    return this.user.first_name;
                } catch {
                    return '';
                }
            },
            lastName() {
                try {
                    return this.user.last_name;
                } catch {
                    return '';
                }
            }
        },
    }
</script>

<style scoped>

</style>